enum INVITE_LOGS_ACTIONS {
    email_invite = "E-mail invite",
    sms_invite = "SMS invite"
};
export default INVITE_LOGS_ACTIONS;